import { DialogDataAttrs } from "../dialog/data.js";
//#region src/core/ui/alert-dialog/data.ts
/** @internal */
const AlertDialogDataAttrs = { ...DialogDataAttrs };
//#endregion
export { AlertDialogDataAttrs };

//# sourceMappingURL=data.js.map